/*global define, console, window, HTMLImageElement, Promise*/

(function (root, factory) {
    "use strict";
    if (typeof define === 'function' && define.amd) {
        define("EmployeeQuotesAlt", ["jquery", "Behaviors"], factory);
    } else {
        root.EmployeeQuotesAlt = factory(root.jQuery, root.Behaviors);
    }
}(this, function ($, Behaviors) {
    "use strict";
    var module = {};
    var moduleInstanceId;

    function EmployeeQuotesAlt(target) {
        //handle multiple instances in one page

        this.moduleInstanceId = '.fl-node-' + target.getAttribute( 'data-employeequotesalt' );

        Behaviors.init(EmployeeQuotesAlt, this, arguments);

        this.element = this.$elem[0];

        this.initEmployeeQuotes( this.moduleInstanceId );
        
    }

    Behaviors.inherit(EmployeeQuotesAlt, Behaviors.Behavior);

    EmployeeQuotesAlt.QUERY = "[data-EmployeeQuotesAlt]";

    EmployeeQuotesAlt.ELEMENTS = {
        quoteItem: ".employee-quote-item",
        quoteToggle: ".EmployeeQuotesAlt .toggle-button",
        employeeModalLink: ".EmployeeQuotesAlt .employee-modal",
        employeeModaClose: ".EmployeeQuotesAlt .employee-modal-box .close"
    };

    EmployeeQuotesAlt.prototype.initEmployeeQuotes = function( instanceId ){

        $( instanceId + " " + EmployeeQuotesAlt.ELEMENTS.quoteItem).hover(function(){
            if( $(window).width() >= 768){
                $(this).toggleClass('active');
            }
        });

        $( instanceId + " " + EmployeeQuotesAlt.ELEMENTS.quoteItem).click(function(){

            // only use this for mobile
            if( $(window).width() < 768){
                $(this).toggleClass('active');
            }

        });

        $( instanceId + " " + EmployeeQuotesAlt.ELEMENTS.employeeModalLink).click(function(e){
            e.preventDefault();
            $(this).parent().siblings('.employee-modal-box ').addClass('open');
            $(this).parent().prepend('<div class="page-overlay"></div>');
            // var descHeight = $('.EmployeeQuotesAlt .employee-modal-box .description').height();
            // console.log(descHeight)
            // if(descHeight > 430){
            //     console.log('ssss')
            //     $('.EmployeeQuotesAlt .employee-modal-box .description').css({
            //         height: '430px',
            //         overflowY: 'scroll'
            //     });
            // }
        });
        $( instanceId + " " + EmployeeQuotesAlt.ELEMENTS.employeeModaClose).click(function(e){
            e.preventDefault();
            $(this).parent().removeClass('open');
            $('.blurb_with_modal .page-overlay').remove();
        });


    }

    
    Behaviors.register_behavior(EmployeeQuotesAlt);

    module.EmployeeQuotesAlt = EmployeeQuotesAlt;


    return module;
}));
